(function () {
  /* PERF: visibleCards(), setupTestimonials() and the empty init() they fed were removed
     here - dead code. init()'s only statement was already commented out, so it ran on
     every DOMContentLoaded and every section:load doing nothing. The live testimonial
     carousel is assets/usf-testimonials.js. */

  function initHeader(root) {
    (root || document).querySelectorAll('[data-usf-mobile-menu-toggle]').forEach(function (button) {
      if (button.dataset.usfReady === 'true') return;

      var header = button.closest('.usf-site-header');
      var menu = header && header.querySelector('[data-usf-mobile-menu]');
      if (!menu) return;

      button.dataset.usfReady = 'true';

      function setOpen(isOpen) {
        menu.classList.toggle('open', isOpen);
        document.body.classList.toggle('usf-menu-open', isOpen);
        button.setAttribute('aria-expanded', String(isOpen));
        menu.setAttribute('aria-hidden', String(!isOpen));
        // A11Y: the closed menu is only translated off-screen, so without `inert` its
        // links stay tabbable while aria-hidden hides them from screen readers - which
        // strands keyboard users on invisible controls. Toggled together on purpose.
        if (isOpen) {
          menu.removeAttribute('inert');
        } else {
          menu.setAttribute('inert', '');
        }
      }

      button.addEventListener('click', function () {
        setOpen(!menu.classList.contains('open'));
      });

      var closeBtn = menu.querySelector('[data-usf-mobile-menu-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

      document.addEventListener('click', function (e) {
        if (menu.classList.contains('open') && !menu.contains(e.target) && !button.contains(e.target)) {
          setOpen(false);
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('open')) setOpen(false);
      });
    });
  }

  function initHeaderSearch(root) {
    (root || document).querySelectorAll('.usf-search').forEach(function (search) {
      if (search.dataset.usfSearchReady === 'true') return;
      search.dataset.usfSearchReady = 'true';

      var btn = search.querySelector('[data-usf-search-btn]');
      var closeBtn = search.querySelector('[data-usf-search-close]');
      var input = search.querySelector('input[type="search"]');
      var mq = window.matchMedia('(max-width: 767px)');

      function open() {
        search.classList.add('usf-search--open');
        document.body.classList.add('usf-search-open');
        if (input) setTimeout(function () { input.focus(); }, 60);
      }
      function close() {
        search.classList.remove('usf-search--open');
        document.body.classList.remove('usf-search-open');
      }

      if (btn) {
        btn.addEventListener('click', function (e) {
          // On mobile the icon opens the predictive-search overlay instead of submitting.
          if (mq.matches && !search.classList.contains('usf-search--open')) {
            e.preventDefault();
            open();
          }
        });
      }
      if (closeBtn) closeBtn.addEventListener('click', close);

      document.addEventListener('click', function (e) {
        if (search.classList.contains('usf-search--open') && !search.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && search.classList.contains('usf-search--open')) close();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader(document);
    initHeaderSearch(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initHeader(event.target);
    initHeaderSearch(event.target);
  });
})();
